export const ORDER_DETAILS_DATA = "ORDER_DETAILS_DATA";
export const ORDER_DETAILS_ERROR_DATA = "ORDER_DETAILS_ERROR_DATA";
export const ORDER_DETAILS_HIDE_ERROR_DATA = "ORDER_DETAILS_HIDE_ERROR_DATA";
export const ORDER_DETAILS_CLEAR_DATA = "ORDER_DETAILS_CLEAR_DATA";
export const ORDER_DETAILS_START_LOADER = "ORDER_DETAILS_START_LOADER";
export const ORDER_DETAILS_STOP_LOADER = "ORDER_DETAILS_STOP_LOADER";
